import React from 'react';
import PropTypes from 'prop-types';
import ADGMAccordion from 'aurora-components/ADGMAccordion/ADGMAccordion';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import withStyles from '@material-ui/core/styles/withStyles';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

const propTypes = {
  classes: PropTypes.object.isRequired,
  owners: PropTypes.array.isRequired,
  muncipalityEn: PropTypes.string.isRequired,
  muncipalityAr: PropTypes.string.isRequired,
};

const OwnerDetail = ({ classes, owners, muncipalityEn, muncipalityAr }) => {
  const owner = owners?.length > 0 ? owners?.find(ownerShip => ownerShip.rightHoldTypeEn === 'Ownership') : {};
  return (
    <ADGMAccordion title={keyEmptyCheck('Owner_details')}>
      <div className={classes.ownerDetails}>
        <Avatar className={classes.ownerAvatarimg} alt='lessor' src='/images/Company.svg' />
        <div>
          <Typography className={classes.ownerName}>{owner?.ownerNameEn}</Typography>
          <Typography className={classes.ownerName}>{owner?.ownerNameAr}</Typography>
        </div>
      </div>
      <Paper>
        <div className={`${classes.titleHead} ${classes.paperTitleBorder}`}>
          <Typography variant='h6' component='h1' className={classes.Title}>
            {keyEmptyCheck('represented_by')}
          </Typography>
        </div>
        <div className={classes.ownerDetails}>
          <Avatar className={classes.ownerAvatarimg} alt='lessor' src='/images/Company.svg' />
          <div>
            <Typography className={classes.ownerName}>{muncipalityEn}</Typography>
            <Typography className={classes.ownerName}>{muncipalityAr}</Typography>
          </div>
        </div>
      </Paper>
    </ADGMAccordion>
  );
};

OwnerDetail.propTypes = propTypes;
// #endregion

export default withStyles(styles)(OwnerDetail);
